export enum Veiculo {
    Onibus = 1,
    Van = 2,
    MicroOnibus = 3,
  }